import React, { useEffect } from "react";

type ProcessStep = {
  index: string;
  title: string;
  description: string;
};

interface ProcessTimelineProps {
  title: string;
  steps: ProcessStep[];
}

const ProcessTimeline: React.FC<ProcessTimelineProps> = ({ title, steps }) => {
  useEffect(() => {
    const nodes = document.querySelectorAll<HTMLElement>(".process-step");

    nodes.forEach((step, i) => {
      step.style.animationDelay = `${i * 0.6}s`;
    });

    let activeIndex = 0;
    const interval = setInterval(() => {
      nodes.forEach(s => s.classList.remove("active"));
      if (nodes[activeIndex]) {
        nodes[activeIndex].classList.add("active");
      }
      activeIndex = (activeIndex + 1) % nodes.length;
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="process-showcase">
      <h2 className="process-title">{title}</h2>

      <div className="process-timeline">
        <div className="process-line" />

        {steps.map((step, i) => (
          <div className="process-step" key={i}>
            <span className="step-index">{step.index}</span>
            <h3>{step.title}</h3>
            <p>{step.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProcessTimeline;
